import {makeResource} from 'app/infrastructure/repository'
import { Client } from './_models';

const CLIENT_ENDPOINT = 'clients';

export default makeResource<Client>(CLIENT_ENDPOINT);

